import { defineComponent, computed } from "vue";
import { u as useHover } from "../../../composables/useHover-88d786c8.mjs";
import { u as useColors } from "../../../composables/useColors-6d98be99.mjs";
const _sfc_main = defineComponent({
  name: "VaTimePickerColumnCell",
  setup() {
    const { isHovered, onMouseEnter, onMouseLeave } = useHover();
    const { getTextColor, getColor } = useColors();
    const styleComputed = computed(() => isHovered.value ? {
      color: getColor(getTextColor(getColor("background-secondary"))),
      background: getColor("background-secondary")
    } : void 0);
    return {
      onMouseEnter,
      onMouseLeave,
      styleComputed
    };
  }
});
export {
  _sfc_main as _
};
//# sourceMappingURL=VaTimePickerColumnCell.vue_vue_type_script_lang-7c5742a0.mjs.map
